import * as React from 'react';

import CheckBox from '@/components/elements/Form/CheckBox';
import { BetType } from '@/lib/apollo/types/gen/graphql';
import { getBetTypeName } from '@/lib/race';

import { Wrapper } from '../style';

interface BetTypeCheckBoxProps {
  selectBetTypes: BetType[];
  buttonList: { betType: BetType; disabled?: boolean }[];
  isModifyingDisabled: (
    key: 'betMethod' | 'betType' | 'wheelAxis',
    arg: string,
  ) => boolean;
  onChange: (checked: boolean, betType: BetType) => void;
}

const BetTypeCheckBox: React.FC<BetTypeCheckBoxProps> = ({
  selectBetTypes,
  buttonList,
  isModifyingDisabled,
  onChange,
}) => {
  return (
    <Wrapper>
      {buttonList.map(item => (
        <CheckBox
          key={`checkBox-${item.betType}`}
          htmlFor={item.betType}
          checked={selectBetTypes.includes(item.betType)}
          onChange={e => onChange(e.target.checked, item.betType)}
          disabled={
            item.disabled || isModifyingDisabled('betType', item.betType)
          }
        >
          {getBetTypeName(item.betType)}
        </CheckBox>
      ))}
    </Wrapper>
  );
};

export default BetTypeCheckBox;
